module.exports = __webpack_public_path__ + "static/media/shape_summer-first.eb2afa32.svg";